import axios from 'axios'

export default {
    // 获取getAccessToken
    getAccessToken({commit}, params){
        return axios.post('/api/open_platform/get_access_token/', params)
    },
    // 获取预授权码
    getPreAuthCode({commit}, params){
        return axios.post('/api/open_platform/proxy_wechat/', params)
    },
    // 使用授权码换取公众号或小程序的接口调用凭据和授权信息
    getMerchantInfo({commit}, params){
        return axios.post('/api/open_platform/proxy_wechat/', params)
    },
    setCompanyAppid({commit}, params){
        return axios.post('/api/open_platform/company_appid/modify/', params)
    },
    getCompanyAuthorizerInfo({commit}, params){
        return axios.post('/api/open_platform/get_company_authorizer_info/', params)
    },
    setAppSecret({commit}, params){
        return axios.post('/api/face/add_wechat_secret_key/', params)
    },
    getWechatPayQrcode({commit}, params){
        return axios.post('/api/background/product/sms/pay', params)
    }
}


// WEBPACK FOOTER //
// ./src/vuex/actions/open_platform.js